/*
This is basically localStorage, but we rewrote it here because
localStorage isn't accessible on Safari private mode.

We want to this (and all usages) with UI-304
*/

type StoreKey = 'success';

interface Store {
  [StoreKey: string]: string;
}

const store: Store = {};

export function getOnce(key: StoreKey) {
  const val = store[key];
  delete store[key];
  return val;
}

export function set(key: StoreKey, val: string) {
  store[key] = val;
}
